import React, { useState } from 'react';
import s from './s.module.less';
import ProListingModal from './ProListingModal';
import { BudgetStatus } from 'types/marketing';
import EmptyIcon from 'assets/common/empty.svg';
import { Button, Spin } from 'antd';
import useBudgetInfo from 'hooks/marketing/useBudgetInfo';
import useAdStatus from 'hooks/marketing/useAdStatus';
interface IProps {
    providerId: number;
    onAdSuccess?: () => void;
}

const ProListings: React.FC<IProps> = ({ providerId, onAdSuccess }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
    const [budgetInfo, _, budgetLoading, refetch] = useBudgetInfo(true, providerId);
    const [adStatus, adStatusLoading, adStatusRefetch] = useAdStatus(true, providerId);

    const handleAddCampaign = () => {
        setModalMode('add');
        setModalVisible(true);
    };

    const handleEditCampaign = () => {
        setModalMode('edit');
        setModalVisible(true);
    };

    const handleModalCancel = () => {
        setModalVisible(false);
    };

    const handleModalSaveSuccess = () => {
        setModalVisible(false);
        refetch();
        if (!adStatus.hasJoinedAdSystem) {
            adStatusRefetch();
            onAdSuccess?.();
        }
    };


    const renderEmptyState = () => (
        <div>
            <div className='flex justify-between items-center mb-6'>
                <h2 className='text-xl font-medium'>Campaign</h2>
                <Button type='primary' onClick={handleAddCampaign}>
                    Add new campaign
                </Button>
            </div>
            <div className='flex items-center flex-col'>
                <div className='text-xl font-medium'>No data</div>
                <img src={EmptyIcon} alt="empty" />
            </div>
        </div>
    );

    const renderCampaignCard = () => {
        if (!budgetInfo) return null;

        return (
            <Spin spinning={budgetLoading || adStatusLoading}>
                <div className={s.campaignCard}>
                    <div className={s.cardHeader}>
                        <h3 className={s.cardTitle}>Campaign</h3>
                        <Button
                            className={s.editButton}
                            onClick={handleEditCampaign}
                        >
                            Edit
                        </Button>
                    </div>

                    <div className={s.cardContent}>
                        <div className={s.fieldGroup}>
                            <div className={s.fieldLabel}>Status</div>
                            <div className={`${s.fieldValue} ${budgetInfo.status === BudgetStatus.ACTIVE ? s.statusActive : s.statusInactive}`}>
                                {budgetInfo.status}
                            </div>
                        </div>

                        <div className={s.fieldGroup}>
                            <div className={s.fieldLabel}>Bid per booking</div>
                            <div className={s.fieldValue}>${budgetInfo.generalBidAmount}</div>
                        </div>

                        <div className={s.fieldGroup}>
                            <div className={s.fieldLabel}>Budget type</div>
                            <div className={s.fieldValue}>{budgetInfo.budgetPeriod}</div>
                        </div>

                        <div className={s.fieldGroup}>
                            <div className={s.fieldLabel}>Budget amount</div>
                            <div className={s.fieldValue}>${budgetInfo.budgetCap}</div>
                        </div>


                        {budgetInfo.updatedAt && (
                            <div className={s.fieldGroup}>
                                <div className={s.fieldLabel}>Last modified</div>
                                <div className={s.fieldValue}>{budgetInfo.updatedAt}</div>
                            </div>
                        )}

                        {budgetInfo.updatedByName && (
                            <div className={s.fieldGroup}>
                                <div className={s.fieldLabel}>Last modified by</div>
                                <div className={s.fieldValue}>{budgetInfo.updatedByName}</div>
                            </div>
                        )}

                        {
                            budgetInfo.specialtyBids && budgetInfo.specialtyBids.length > 0 && (
                                <div className={s.fieldGroup}>
                                    <div className={s.fieldLabel}>Custom bids by specialty</div>
                                    <div className={s.fieldValue}>
                                        {budgetInfo.specialtyBids.filter(item => item.enabled).map((item) => (
                                            <div key={item.specialtyName} className={s.bidItem}>
                                                <span className={s.bidSpecialty}>{item.specialtyName}: </span>
                                                <span className={s.bidAmount}>${item.bidAmount}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </Spin>
        )
    };

    return (
        <div className={s.container}>
            {adStatus.hasJoinedAdSystem ? (
                renderCampaignCard()
            ) : (
                renderEmptyState()
            )}

            <ProListingModal
                visible={modalVisible}
                mode={modalMode}
                initialData={budgetInfo}
                onCancel={handleModalCancel}
                providerId={providerId}
                onSaveSuccess={handleModalSaveSuccess}
                hasJoinedAdSystem={adStatus.hasJoinedAdSystem}
            />
        </div>
    );
};

export default ProListings;